import React, { Component } from 'react'
import moment from 'moment'
import Constant, { getCountryTimeZone, getTypeTags } from '../../Constant'
import Swal from 'sweetalert2'
// import Calendar from 'react-calendar'
import axios from 'axios'
import Loader from '../../common/Loader'
import StandaloneCalendar from '../../common/CustomComponents/Calendar/StandaloneCalendar'
const momentTz = require('moment-timezone')

class EditCruiseModel extends Component {
  state = {
    isLoading: false,
    selected_cruise_id: '',
    booking_date: '',
    total_booking_amount: 0,
    destination_fee: 0,
    pick_up_id: '',
    booking_status: '',
    destination_id: '',
    slot_start_from: '',
    time_slots: [],
    slotData: [],
    slots: [],
    destination_list: [],
    is_paydo_store: false,
    destination_min_hr: 0,
    timeSlots: [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
    ],
    Availabletimeslots: {},
    arrayBlockedslots: [],
    arrayBookedslots: [],
    arrayTimeslots: [],
    newClass: [],
    selectedSlot: null,
    bookingDateRange: null,
  }

  handleChange = (event) => {
    event.persist()
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event?.target?.name == 'selected_cruise_id') {
          this.setState({
            destination_id: '',
            selectedSlot: '',
          })
          this.getAvailableDestinationListForEdit()
        }
        if (event?.target?.name == 'destination_id' || event?.target?.name == 'selected_cruise_id') {
          this.getSlots()
          this.getAvailabletimeslots()
        }
        this.calculateSlots()
      }
    )
  }

  handleSlotChange = (slot) => {
    this.setState(
      (prevState) => ({
        selectedSlot: prevState.selectedSlot === slot ? null : slot,
        slot_start_from: slot,
      }),
      () => {
        this.calculateSlots()
      }
    )
  }

  // Memoized getter to avoid creating new objects on every render
  _initialSelectedDateRange = null
  _lastBookingDate = null
  _lastBookingToDate = null

  getInitialSelectedDateRange = () => {
    const { booking_date, booking_to_date } = this.props.bookingDetails || {}

    // Only create new object if values have actually changed
    if (this._lastBookingDate !== booking_date || this._lastBookingToDate !== booking_to_date) {
      this._lastBookingDate = booking_date
      this._lastBookingToDate = booking_to_date
      this._initialSelectedDateRange = {
        from: booking_date,
        to: booking_to_date,
      }
    }

    return this._initialSelectedDateRange
  }

  componentDidMount = () => {
    this.setState(
      {
        booking_date: this.props.bookingDetails?.booking_date,
        destination_list: this.props.destinationList,
        selected_cruise_id: this.props.bookingDetails?.cruise_id,
        total_booking_amount:
          this.props.bookingDetails?.total_booking_amount - this.props.bookingDetails?.extra_payment,
        destination_fee: this.props.bookingDetails?.destination_fee,
        type_tag: this.props.bookingDetails?.type_tag,
        pick_up_id: this.props.bookingDetails?.pick_up_id,
        booking_status: this.props.bookingDetails?.booking_status,
        destination_id: this.props.bookingDetails?.destination_id,
        slot_start_from: this.props.bookingDetails?.slots?.[0]?.slot_from,
        selectedSlot: this.props.bookingDetails?.slots?.[0]?.slot_from?.split(':')?.[0],
        is_paydo_store: this.props.bookingDetails?.additional_items?.find(
          (ele) => ele.store_item?.store?.is_paydo_store
        ),
      },
      () => {
        if (moment(this.state.booking_date, 'YYYY-MM-DD').startOf('day').isSameOrAfter(moment().startOf('day'))) {
          this.getAvailabletimeslots()
        } else if (localStorage.getItem('loged_In_role') == 'super-admin') {
          this.setState({
            arrayTimeslots: this.state.timeSlots,
          })
        }
        this.getSlots()
        this.calculateSlots()
      }
    )
  }

  calculateSlots = () => {
    let minDestinationHr = this.state.destination_list?.find(
      (itm) => itm.id == this.state?.destination_id
    )?.destination_min_hour
    let slotLength = parseInt(minDestinationHr?.split(':')[0])

    let slots = []
    if (this.state.slot_start_from) {
      let startingSlot = moment(this.state.slot_start_from, 'HH:mm:ss')

      while (slotLength >= 0) {
        slots.push(startingSlot.format('HH:mm'))
        startingSlot.add('1', 'hour')
        slotLength = slotLength - 1
      }
    }
    this.setState({
      time_slots: slots,
    })
  }

  saveDetails = () => {
    if (!this.state.destination_id) {
      Swal.fire('Select destination', '', 'error')
      return
    }

    if (this.props.bookingDetails.destination.book_by === 'day') {
      this.props.editBookingCruise(this.state)
    } else {
      if (!this.state.selectedSlot) {
        Swal.fire('Select slot', '', 'error')
        return
      }

      if (this.state.time_slots.length > 0) {
        for (let i = 0; i < this.state.time_slots.length; i++) {
          const element = this.state.time_slots[i]
          const timePattern = /^(?:2[0-3]|[01]?[0-9]):[0-5][0-9]$/

          if (!timePattern.test(element)) {
            Swal.fire({
              title: 'Invalid Time slots.',
              icon: 'error',
            })
            return
          }

          // if (!this.state.slots.includes(element.split(':')[0])) {
          //   Swal.fire('Invalid slots selection', '', 'warning')
          //   this.setState({
          //     slot_start_from: '',
          //     time_slots: []
          //   })
          //   return;
          // }
        }

        this.props.editBookingCruise(this.state)
      } else {
        Swal.fire({
          title: 'Please check Slots are missing.',
          icon: 'error',
        })
      }
    }
  }

  tileDisabled = (date) => {
    // Allow super-admin to edit back dates
    if (localStorage.getItem('loged_In_role') == 'super-admin') {
      return false
    }
    const checkIfDateExists = this.state.slotData?.calendarData?.find(
      (ele) => ele.enable && ele.date === moment(date.date).format('YYYY-MM-DD')
    )
    if (checkIfDateExists) {
      return false
    }
    return true
  }

  handleBookingDate = (event) => {
    if (this.props.bookingDetails.destination.book_by === 'day') {
      this.setState({
        bookingDateRange: event,
      })
    } else {
      this.setState(
        {
          booking_date: moment(event).format('YYYY-MM-DD'),
          selectedSlot: null,
        },
        () => {
          if (moment(this.state.booking_date, 'YYYY-MM-DD').startOf('day').isSameOrAfter(moment().startOf('day'))) {
            this.getSlots()
            this.getAvailabletimeslots()
          } else {
            this.setState({
              arrayBlockedslots: [],
              arrayBookedslots: [],
              arrayTimeslots: this.state.timeSlots,
            })
          }
        }
      )
    }
  }

  handleMonthChange = (event) => {
    if (event?.activeStartDate) {
      let selectedDate = event.activeStartDate
      if (moment(selectedDate).month() == moment().month()) {
        selectedDate = moment().format('YYYY-MM-DD')
      } else {
        selectedDate = moment(selectedDate).format('YYYY-MM-DD')
      }
      this.setState(
        {
          booking_date: selectedDate,
          selectedSlot: null,
          arrayTimeslots: [],
          arrayBlockedslots: [],
          arrayBookedslots: [],
        },
        () => {
          if (moment(this.state.booking_date, 'YYYY-MM-DD').startOf('day').isSameOrAfter(moment().startOf('day'))) {
            this.getSlots()
            this.getAvailabletimeslots()
          } else if (localStorage.getItem('loged_In_role') == 'super-admin') {
            this.setState({
              arrayTimeslots: this.state.timeSlots,
            })
          }
        }
      )
    }
  }

  setSlots = (slot, nextDay = false) => {
    const { destination_min_hr, additional_hour, calendar_slots } = this.state
    const minTime = destination_min_hr
    const index = calendar_slots.map((ele) => ele.label.split(':')[0]).indexOf(slot)
    const length = calendar_slots.length
    const bookedSlots = calendar_slots.filter((ele) => !ele.enable).map((ele) => ele.label.split(':')[0])

    // Calculate the total number of slots needed
    const totalSlotsNeeded = minTime + (parseInt(additional_hour?.split(':')?.[0]) || 0)

    // Check if the slots are within bounds
    if (index + totalSlotsNeeded <= length && !nextDay) {
      // Check if any of the slots in the range are booked
      for (let i = index; i < index + totalSlotsNeeded; i++) {
        if (bookedSlots.includes(!calendar_slots[i]?.nextDay && calendar_slots[i]?.label?.split(':')?.[0])) {
          this.setState({ slot: '', additional_hour: '', slot_checked: [] })
          return
        }
      }

      // If all slots in the range are available, create the SlotGroup
      let SlotGroup = slot
      for (let i = index + 1; i < index + totalSlotsNeeded; i++) {
        SlotGroup += ',' + calendar_slots[i]?.label?.split(':')?.[0]
      }
      const slotsGroupData = SlotGroup?.split(',') || []
      const slotChecked = []
      const indexOfLastSlot = slotsGroupData.indexOf('23')

      // Check if slots contain next day slot or not.
      if (indexOfLastSlot !== -1) {
        for (let index = indexOfLastSlot; index < slotsGroupData.length; index++) {
          if (parseInt(slotsGroupData[index]) > parseInt(slotsGroupData[index + 1])) {
            slotChecked.push(this.state.booking_date + ` ${slotsGroupData[index]}:00:00`)
          } else {
            slotChecked.push(
              moment(this.state.booking_date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD') +
                ' ' +
                `${slotsGroupData[index]}:00:00`
            )
          }
        }
        for (let index = 0; index < indexOfLastSlot + 1; index++) {
          slotChecked.push(this.state.booking_date + ` ${slotsGroupData[index]}:00:00`)
        }
      } else {
        for (let index = 0; index < slotsGroupData.length; index++) {
          slotChecked.push(this.state.booking_date + ` ${slotsGroupData[index]}:00:00`)
        }
      }
      const slotStartFrom = `${SlotGroup?.split(',')?.[0]}:00:00`
      this.setState({ slot: SlotGroup, slot_checked: slotChecked, slot_start_from: slotStartFrom })
      return 1
    } else {
      this.setState({ slot: '', slot_checked: [], slot_start_from: '' })
      return 0
    }
  }

  getSlots = async () => {
    this.setState({
      slotData: [],
      slots: [],
      // slot_start_from: '',
      isLoading: true,
    })
    const { booking_date, destination_id, selected_cruise_id } = this.state
    if (selected_cruise_id && booking_date && destination_id) {
      const data = {
        cruise_id: selected_cruise_id,
        date: moment(booking_date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
        destination_id: destination_id,
      }
      await axios
        .post(Constant?.getAPI() + `/booking/check-available-slots-v3`, data, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
            isguest: true,
          },
        })
        .then((res) => {
          if (res?.data?.success) {
            // const slotList = res.data?.data?.slotList || []
            let minDestinationHr = this.state.destination_list?.find(
              (itm) => itm.id == this.state?.destination_id
            )?.destination_min_hour

            const destinationMinHr = parseInt(minDestinationHr?.split(':')?.[0])
            // const nextDaySlotList = res.data?.data?.nextDaySlots?.slice(0, destinationMinHr - 1) || []
            // let dateSlotObj = {}
            // let availableSlot = ''
            // for (let item of res.data?.data?.calendarData) {
            //   if (!availableSlot && item.enable) {
            //     availableSlot = moment(item.date).format('YYYY-MM-DD')
            //   }
            //   dateSlotObj['date-' + parseInt(moment(item.date).format('DD'))] = {
            //     enable: item.enable,
            //     price: item.price,
            //   }
            // }

            // const calendarSlotsArr = getHourSlots().reduce((acc, slot) => {
            //   const hour = slot.value.split(':')[0]
            //   if (hour !== '24') {
            //     acc.push({
            //       ...slot,
            //       enable: slotList.includes(hour),
            //       nextDay: false,
            //       uniqueValue: this.state.booking_date + ' ' + slot.value,
            //       date: this.state.booking_date,
            //     })
            //   }
            //   return acc
            // }, [])

            // if (nextDaySlotList.length > 0) {
            //   for (const slt of nextDaySlotList) {
            //     calendarSlotsArr.push({
            //       label: `${slt}:00`,
            //       value: `${slt}:00:00`,
            //       nextDay: true,
            //       enable: true,
            //       uniqueValue:
            //         moment(this.state.booking_date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD') + ' ' + `${slt}:00:00`,
            //       date: moment(this.state.booking_date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD'),
            //     })
            //   }
            // }
            this.setState({
              slotData: res.data.data,
              slots: res.data.data?.slotList,
              // calendarDateCellStatus: dateSlotObj,
              // calendar_slots: calendarSlotsArr,
              // next_day_slots: nextDaySlotList,
              calendarData: res.data?.data?.calendarData,
              destination_min_hr: destinationMinHr,
            })
            this.calculateSlots()
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
    this.setState({
      isLoading: false,
    })
  }

  getAvailableDestinationListForEdit = async () => {
    this.setState({
      destination_list: [],
      isLoading: true,
    })
    if (this.state.selected_cruise_id) {
      await axios
        .get(Constant?.getAPI() + `/booking/get-destination-list/` + this.state.selected_cruise_id, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res?.data?.success) {
            this.setState({ destination_list: res.data.data?.destinationList })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
    this.setState({
      isLoading: false,
    })
  }

  getAvailabletimeslots = async () => {
    this.setState({
      isLoading: true,
      arrayBlockedslots: [],
      arrayBookedslots: [],
      arrayTimeslots: [],
      Availabletimeslots: {},
    })

    const data = {
      cruise_id: this.state.selected_cruise_id,
    }

    await axios
      .post(Constant.getAPI() + `/slots/get-calendar-time-slots`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          const selectedDate = res?.data?.data?.find((itm) => itm.cruise_booking_date === this.state.booking_date)
          if (selectedDate) {
            selectedDate.time_slots.sort((a, b) => a.localeCompare(b))
            this.setState(
              {
                Availabletimeslots: selectedDate,
              },
              () => {
                this.setState({
                  arrayBlockedslots: this.state.Availabletimeslots.block_slots,
                  arrayBookedslots: this.state.Availabletimeslots.booked_slots,
                  arrayTimeslots: this.state.Availabletimeslots.time_slots,
                })
              }
            )
          } else {
            this.setState({
              arrayTimeslots: [],
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message, '', 'error')
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  checkSlotAvailable = (date, time) => {
    let slot = moment(`${date} ${time}:00:00`).format('YYYY-MM-DD HH:mm:ss')
    let currentTime = momentTz()
      .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
      .format('YYYY-MM-DD HH:mm:ss')
    return moment(currentTime).isAfter(moment(slot))
  }

  handleRangeError = (errorType, message) => {
    this.setState({
      bookingDateRange: null,
    })

    Swal.fire({
      title: 'Selection Error',
      icon: 'warning',
      text: message,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }

  render() {
    return (
      <div>
        {this.state.isLoading && (
          <Loader
            open={true}
            fullPage={true}
          />
        )}
        <div className="header">
          <b>Edit Booking</b>
        </div>
        <div className="body m-t-20">
          {/* <div
            className="row"
            style={{
              borderTop: '1px solid #ddd',
              borderBottom: '1px solid #ddd',
              marginBottom: 10,
              padding: 10,
            }}
          >
            <div
              className="col-12"
              style={{ fontWeight: 'bold' }}
            >
              Previously Selected
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-3">sdfsdf</div>
                <div className="col-9">sdfsdf</div>
              </div>
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-3">sdfsdf</div>
                <div className="col-9">sdfsdf</div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Booking Status</label>
                <div className="col-9">
                  <select
                    name="booking_status"
                    className="form-control"
                    value={this.state.booking_status}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    <option value="Pending">Pending</option>
                    <option value="Confirmed">Confirmed</option>
                    <option value="Successful">Successful</option>
                    <option value="Postponed">Postponed</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Sailed">Sailed</option>
                  </select>
                  {this.state.is_paydo_store && (
                    <div style={{ color: 'red' }}>
                      To cancel store items order, Need to contact with <b>Paydo Team</b>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Booking Type tag</label>
                <div className="col-9">
                  <select
                    name="type_tag"
                    className="form-control"
                    value={this.state.type_tag}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    {getTypeTags().map((itm) => (
                      <option
                        value={itm}
                        key={itm}
                      >
                        {itm}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">
                  Select {this.props?.bookingDetails?.cruise?.category?.cruise_cat_en || 'Cruise'}
                </label>
                <div className="col-9">
                  <select
                    name="selected_cruise_id"
                    className="form-control"
                    value={this.state.selected_cruise_id}
                    onChange={this.handleChange}
                  >
                    <option
                      value={''}
                      key={''}
                    >
                      Select {this.props?.bookingDetails?.cruise?.category?.cruise_cat_en || 'Cruise'}
                    </option>
                    {this.props.cruiseList.map((itm) => (
                      <option
                        value={itm.id}
                        key={itm.id}
                      >
                        {itm.cruise_name_en} / {itm.cruise_name_ar}
                      </option>
                    ))}
                  </select>
                  <div style={{ color: 'red' }}>This will change cruise and captain for this booking</div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Pickup Position</label>
                <div className="col-9">
                  <select
                    name="pick_up_id"
                    className="form-control"
                    value={this.state.pick_up_id}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    {this.props.pickupList.map((itm) => (
                      <option
                        value={itm.id}
                        key={itm.id}
                      >
                        {itm.pickup_address_en}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Destination</label>
                <div className="col-9">
                  <select
                    name="destination_id"
                    className="form-control"
                    value={this.state.destination_id}
                    onChange={this.handleChange}
                  >
                    <option value={''}>Select Destination</option>
                    {this.state.destination_list
                      ?.filter((itm) => itm.book_by == this.props.bookingDetails.destination.book_by)
                      ?.map((itm) => (
                        <option
                          value={itm.id}
                          key={itm.id}
                        >
                          {itm.destination_address}(
                          {itm.book_by == 'hours' ? itm.destination_min_hour : `${itm.min_days} - ${itm.max_days} days`}
                          )
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-12"></div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Select Booking Date</label>
                <div className="col-9">
                  {/* <Calendar
                    className="full-width"
                    value={this.state.booking_date}
                    tileDisabled={(date) => this.tileDisabled(date)}
                    onChange={this.handleBookingDate}
                    onActiveStartDateChange={this.handleMonthChange}
                  /> */}
                  <StandaloneCalendar
                    mode={this.props.bookingDetails.destination.book_by === 'day' ? 'range' : 'single'}
                    onChange={this.handleBookingDate}
                    onMonthChange={this.handleMonthChange}
                    onRangeError={this.handleRangeError}
                    disablePastDates={false}
                    {...(this.props.bookingDetails.destination.book_by === 'day'
                      ? {
                          minDays: parseInt(this.props.bookingDetails.destination.min_days) || 1,
                          maxDays: parseInt(this.props.bookingDetails.destination.max_days) || 30,
                          initialSelectedDateRange: this.getInitialSelectedDateRange(),
                        }
                      : {
                          initialSelectedDate: this.state.booking_date,
                          persistSelectedDate: true,
                        })}
                  />
                </div>
              </div>
            </div>
            {this.props.bookingDetails.destination.book_by == 'hours' && (
              <div className="col-6">
                <div className="form-group row">
                  <label className="col-3 col-form-label">Slot start from</label>
                  <div className="col-9">
                    {this.state.timeSlots.map((item, i) => (
                      <button
                        key={i}
                        style={{ margin: 2, width: 70 }}
                        className={`btn btn-sm ${
                          this.state.selectedSlot === item
                            ? 'selectedSlot'
                            : this.state.arrayBookedslots.includes(item)
                              ? 'bookedSlot'
                              : this.state.arrayBlockedslots.includes(item)
                                ? 'BlockedSlot'
                                : !this.state.arrayTimeslots.includes(item)
                                  ? 'Inactive'
                                  : 'Timeslots'
                        }`}
                        disabled={
                          // this.checkSlotAvailable(this.state.Availabletimeslots?.cruise_booking_date, item) ||
                          this.state.arrayBlockedslots.includes(item) ||
                          this.state.arrayBookedslots.includes(item) ||
                          (!this.state.arrayTimeslots.includes(item) && !this.state.arrayBlockedslots.includes(item))
                            ? true
                            : false
                        }
                        onClick={() => this.handleSlotChange(item)}
                      >
                        {item}:00
                      </button>
                    ))}
                    <div style={{ color: 'red' }}>TimeSlots:- {this.state.time_slots.join(', ')}</div>
                  </div>
                  <div className="col-12 m-t-20">
                    <div className="row">
                      <div className="col-3">
                        <div className="col-12 text-center">
                          <div
                            className="selectedSlot"
                            style={{ height: 15, borderRadius: '10px' }}
                          ></div>{' '}
                          Selected
                        </div>
                      </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-3 text-center">
                            <div
                              className="bookedSlot"
                              style={{ height: 15, borderRadius: '10px' }}
                            ></div>{' '}
                            Booked
                          </div>
                          <div className="col-3 text-center">
                            <div
                              className="Timeslots"
                              style={{ height: 15, borderRadius: '10px' }}
                            ></div>{' '}
                            Available
                          </div>
                          <div className="col-3 text-center">
                            <div
                              className="BlockedSlot"
                              style={{ height: 15, borderRadius: '10px' }}
                            ></div>{' '}
                            Blocked
                          </div>
                          <div className="col-3 text-center">
                            <div
                              className="Inactive"
                              style={{ height: 15, borderRadius: '10px' }}
                            ></div>{' '}
                            Inactive
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-12"></div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Cruise Amount</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={this.state.destination_fee}
                    name="destination_fee"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Total Booking Amount</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={this.state.total_booking_amount}
                    name="total_booking_amount"
                    onChange={this.handleChange}
                  />
                  <div style={{ color: 'red' }}>After changing this it may effect booking details on mobile app</div>
                </div>
              </div>
            </div>
            {/* <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Slot start from</label>
                <div className="col-9">
                  {this.state.slots.length > 0 ? (
                    <div className="time-data">
                      {this.state.calendar_slots.map((slot) => (
                        <span
                          key={slot.uniqueValue}
                          style={{}}
                          className={
                            !slot.nextDay
                              ? slot.enable
                                ? (this.state.slot_checked?.includes(slot.uniqueValue) ? 'slot-select' : '') +
                                ' time-list'
                                : 'time-list-disable'
                              : slot.enable
                                ? (this.state.slot_checked?.includes(slot.uniqueValue) ? 'slot-select' : '') +
                                ' time-list-next-day'
                                : 'time-list-next-day time-list'
                          }
                          onClick={() => this.setSlots(slot.label.split(':')[0], slot.nextDay)}
                        >
                          {slot.label}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <div className="mt-3 no-data">
                      <h5 className="">No slots available</h5>
                    </div>
                  )}
                </div>
              </div>
            </div> */}
            {/* <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Slot start from</label>
                <div className="col-9">
                  <select
                    name="slot_start_from"
                    className="form-control"
                    value={this.state.slot_start_from}
                    onChange={this.handleChange}
                  >
                    {getHourSlots().map(
                      (itm) =>
                        itm.value != '24:00:00' && (
                          <option
                            value={itm.value}
                            key={itm.value}
                          >
                            {itm.label}
                          </option>
                        )
                    )}
                  </select>
                  <div style={{ color: 'red' }}>TimeSlots:- {this.state.time_slots.join(', ')}</div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-12">
                <div className="form-group row">
                    <label className="col-3 col-form-label">
                        Vat Amount<span style={{color:'red', fontSize: '12px', fontWeight: '500'}}> (For KSA)</span>
                    </label>
                    <div className="col-9">
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter amount"
                            value={this.state.destination_fee}
                            name="destination_fee"
                            onChange={this.handleChange}
                            disabled={localStorage.getItem('countryShortName') != 'KSA'}
                        />
                    </div>
                </div>
            </div> */}
          </div>
          <div className="row">
            <div className="text-right col-6 offset-6">
              {(() => {
                let isDisabled = true

                if (this.props.bookingDetails.destination.book_by === 'day') {
                  isDisabled =
                    this.state.selected_cruise_id == this.props.bookingDetails?.cruise_id &&
                    this.state.booking_date == this.props.bookingDetails.booking_date &&
                    this.state.total_booking_amount == this.props.bookingDetails.total_booking_amount &&
                    this.state.type_tag == this.props.bookingDetails.type_tag &&
                    this.state.destination_fee == this.props.bookingDetails.destination_fee &&
                    this.state.pick_up_id == this.props.bookingDetails.pick_up_id &&
                    this.state.destination_id == this.props.bookingDetails.destination_id &&
                    this.state.booking_status == this.props.bookingDetails.booking_status &&
                    this.state.bookingDateRange?.from == this.props.bookingDetails.booking_date &&
                    this.state.bookingDateRange?.to == this.props.bookingDetails.booking_to_date
                } else if (this.props.bookingDetails.destination.book_by !== 'day') {
                  isDisabled =
                    this.state.selected_cruise_id == this.props.bookingDetails?.cruise_id &&
                    this.state.booking_date == this.props.bookingDetails.booking_date &&
                    this.state.total_booking_amount == this.props.bookingDetails.total_booking_amount &&
                    this.state.type_tag == this.props.bookingDetails.type_tag &&
                    this.state.destination_fee == this.props.bookingDetails.destination_fee &&
                    this.state.pick_up_id == this.props.bookingDetails.pick_up_id &&
                    this.state.destination_id == this.props.bookingDetails.destination_id &&
                    this.state.booking_status == this.props.bookingDetails.booking_status &&
                    this.state.slot_start_from == this.props.bookingDetails.slots[0]?.slot_from
                }

                return (
                  <button
                    onClick={this.saveDetails}
                    className="btn hor-grd btn-grd-inverse offset-1"
                    disabled={isDisabled}
                  >
                    Save
                  </button>
                )
              })()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default EditCruiseModel
